import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import { IntegrationsProviderWrapper } from './context';
import IntegrationsHomePage from './pages/IntegrationsHomePage';
import ProviderDetailLayout from './pages/ProviderDetailLayout';
import InstanceDetailLayout from './pages/InstanceDetailLayout';
import RequestIntegrationModal from './components/modals/RequestIntegrationModal';

/**
 * Domain root for Integrations. Owns internal routes and wraps with providers.
 *
 * Paths are RELATIVE to the parent route that mounts this component
 * (`admin-studio/integrations/*`). Internal links are relative — never absolute
 * `/admin-studio/...` — so the domain works in both standalone and embedded modes.
 */
const Integrations = () => (
  <IntegrationsProviderWrapper>
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <IntegrationsHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":providerSlug/instances/:instanceId/*"
        element={
          <ProtectedRoute>
            <InstanceDetailLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path=":providerSlug/*"
        element={
          <ProtectedRoute>
            <ProviderDetailLayout />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
    {/* Global Request Integration modal (CT-4175) — available from every surface. */}
    <RequestIntegrationModal />
  </IntegrationsProviderWrapper>
);

export default Integrations;
